import { Link } from 'react-router-dom';
import { IMaintenanceResource } from '../../entities/farms.entities';
import { useSelector } from 'react-redux';
import { selectFarmsData } from '../../store/farms/farms.selector';
import { translate } from '../../lib/lang.helper';
import { selectLang } from '../../store/ui/ui.selector';
import { FarmDiv, LineDiv } from './CalendarCell';

const typeLabel: any = {
  VISUAL_ASSESSMENT: 'Visual Assessment',
  LINE_CLEANING: 'Line Cleaning',
  GENERAL_MAINTENANCE: 'General Maintenance',
};

interface Props {
  mntData: IMaintenanceResource;
  onShowMaintenance: (d: any) => void;
}

const MaintenanceCell = ({ mntData, onShowMaintenance }: Props) => {
  const lang = useSelector(selectLang);
  const farm = useSelector(selectFarmsData).find(f =>
    f.lines.some(x => x.id === mntData.line_id),
  );
  const line = farm?.lines.find(x => mntData.line_id);
  const handleClick = (event: any) => {
    event.preventDefault();
    onShowMaintenance({ line: line, data: mntData });
  };

  return (
    <div className='--entity --maintenance' onClick={handleClick.bind(this)}>
      <div className='--header'>
        <span>{translate(lang, 'maintenance')}</span>
      </div>
      <div className='--title'>
        <div className='mt-7'>
          {translate(lang, typeLabel[mntData.type] ?? 'General Maintenance')}
        </div>
        <div className='d-flex flex-wrap gap-7'>
          {farm && <FarmDiv farm={farm} />}
          {line && <LineDiv line={line} />}
        </div>
      </div>
      <div className='--btn-bar'>
        <Link to={`/farms/${farm?.id}/${line?.id}`} className='--view'>
          {translate(lang, 'View')}
        </Link>
      </div>
    </div>
  );
};

export default MaintenanceCell;
